import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ecaparticipants',
  templateUrl: './ecaparticipants.component.html',
  styleUrls: ['./ecaparticipants.component.css']
})
export class EcaparticipantsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
